export const gstinRegExp = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const hsnRegExp = /^[0-9]{4,8}$/;
export const todaysDate = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

